<button type="button" class="btn" aria-label="Choose" 
    [ngClass]="{'btn-checked': isChoose, 'btn-not-checked': !isChoose}" (click)="emitChoose()">

    {{'ACTIONS.CHOOSE' | translate}}
    <i class="bi bi-plus" *ngIf="!isChoose"></i>
    <i class="bi bi-check" *ngIf="isChoose"></i>
</button>